import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { RouterLink } from 'APP/router/constants';
import Entities from 'STORE';

interface IForceUpdatePresenter {
  isNeedForceUpdate: boolean;
  handleUpdate(): void;
}

export function useForceUpdatePresenter(): IForceUpdatePresenter {
  const navigate = useNavigate();

  const presenter = useLocalStore(() => ({
    get isNeedForceUpdate(): boolean {
      return Entities.authStore.isNeedForceUpdate;
    },

    handleUpdate(): void {
      window.location.reload();
    },
  }));

  useEffect(() => {
    if (!presenter.isNeedForceUpdate) {
      navigate(RouterLink.Main);
    }
  }, [presenter.isNeedForceUpdate]);

  return presenter;
}
